import { ChangeDetectorRef, Component } from '@angular/core';

import { NavigationLink } from '@stylehaven/components';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { defaultNavigationOptions } from '../../../../entities/navigation/navigation-options.entity';
import { RecordNavigationService } from '../../../../services/navigation/record-navigation.service';
import { ApiFragment } from '../../../entities/api-fragment.entity';
import { GetFieldPipe } from '../../../pipes/get-field.pipe';
import { TextCellComponent } from '../text-cell/text-cell.component';

@Component({
    standalone: false,
    selector: 'digihaven-title-cell',
    templateUrl: './title-cell.component.html',
    styleUrls: ['./title-cell.component.scss']
})
export class TitleCellComponent extends TextCellComponent {
    navigationLink$!: Observable<NavigationLink>;

    constructor(
        fieldPipe: GetFieldPipe,
        cd: ChangeDetectorRef,
        private navigationService: RecordNavigationService
    ) {
        super(fieldPipe, cd);
        this.buildNavigationLink();
    }

    recordSelected(record: ApiFragment): void {
        this.rowNavigation.emit(record);
    }

    buildNavigationLink(): void {
        this.navigationLink$ = combineLatest([this.data$, this.overviewId$]).pipe(
            map(([record, overviewId]) => {
                return this.navigationService.getNavigationLink({
                    record,
                    navigationOptions: {
                        ...defaultNavigationOptions,
                        queryParams: {
                            ['overview']: overviewId
                        }
                    }
                });
            })
        );
    }
}
